import Swiper from 'swiper';

class ProductMediaGallery {
    constructor(el, options = {}) {
        this.el = el;
        this.mainCarouselSelector = this.el.querySelector('.js-product-media-gallery');
        this.thumbsCarouselSelector = this.el.querySelector('.js-product-media-gallery-thumbs');

        // Navigation buttons
        this.prevButton = this.el.querySelector('.js-prev-button');
        this.nextButton = this.el.querySelector('.js-next-button');
        this.thumbsPrevButton = this.el.querySelector('.js-thumbs-prev-button');
        this.thumbsNextButton = this.el.querySelector('.js-thumbs-next-button');

        // Current slide from data attribute or options
        this.currentSlide = options.currentSlide || parseInt(this.el.dataset.currentSlide) || 0;
        this.init();
    }

    init() {
        // Initialize product media gallery carousel first
        this.thumbsCarousel = new Swiper(this.thumbsCarouselSelector, {
            slidesPerView: 3,
            spaceBetween: 16,
            watchSlidesProgress: true,
            centeredSlides: false,
            slideToClickedSlide: true,
            navigation: {
                nextEl: this.thumbsNextButton,
                prevEl: this.thumbsPrevButton
            },
            breakpoints: {
                640: {
                    slidesPerView: 5
                },
                768: {
                    slidesPerView: 'auto'
                }
            }
        });

        // Initialize main carousel and sync with thumbnails
        this.mainCarousel = new Swiper(this.mainCarouselSelector, {
            spaceBetween: 10,
            initialSlide: this.currentSlide,
            navigation: {
                nextEl: this.nextButton,
                prevEl: this.prevButton
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            a11y: {
                prevSlideMessage: (this.prevButton && this.prevButton.getAttribute('aria-label')) || 'Föregående bild',
                nextSlideMessage: (this.nextButton && this.nextButton.getAttribute('aria-label')) || 'Nästa bild'
            },
            on: {
                init: () => {
                    this.dispatchCurrentSlide();
                },
                slideChange: () => {
                    this.dispatchCurrentSlide();
                    this.thumbsCarousel.slideTo(this.mainCarousel.activeIndex);
                }
            }
        });
        this.attachEventListeners();

        // Update to current slide for both carousels
        this.mainCarousel.slideTo(this.currentSlide, 0, false);
        this.thumbsCarousel.slideTo(this.currentSlide, 0, false);
    }

    // Dispatchar currentSlide-event på galleriets root-element
    dispatchCurrentSlide() {
        if (!this.el || !this.mainCarousel) return;
        const activeIndex = this.mainCarousel.activeIndex != null ? this.mainCarousel.activeIndex : 0;
        this.el.dispatchEvent(new CustomEvent('currentSlide', { detail: { slide: activeIndex } }));
    }

    attachEventListeners() {
        // Click and keyboard events for thumbnails
        const thumbnails = this.thumbsCarouselSelector.querySelectorAll('.product-media-gallery__thumbnail');
        thumbnails.forEach((thumb, index) => {
            // Click on thumbnail
            thumb.addEventListener('click', () => {
                this.mainCarousel.slideTo(index);
            });
            // Keyboard navigation for thumbnails
            thumb.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.mainCarousel.slideTo(index);
                }
            });
        });

        // Avoid attaching keyboard for double triggering - let Swiper handle it
        if (this.nextButton) {
            this.nextButton.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                }
            });
        }
        if (this.prevButton) {
            this.prevButton.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                }
            });
        }
    }

    goToSlide(index) {
        if (this.mainCarousel) {
            this.mainCarousel.slideTo(index);
        }
    }

    destroy() {
        // Destroy carousels
        if (this.mainCarousel) {
            this.mainCarousel.destroy(true, true);
        }
        if (this.thumbsCarousel) {
            this.thumbsCarousel.destroy(true, true);
        }
    }
}

export default ProductMediaGallery;
